import { render, staticRenderFns } from "./DataProducts.vue?vue&type=template&id=39b23b22&scoped=true&"
import script from "./DataProducts.vue?vue&type=script&lang=js&"
export * from "./DataProducts.vue?vue&type=script&lang=js&"
import style0 from "./DataProducts.vue?vue&type=style&index=0&id=39b23b22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b23b22",
  null
  
)

export default component.exports